export default "__VITE_ASSET__DhRSifhJ__"